import Vue from 'vue'
import VueI18n from 'vue-i18n'

import App from '@/App'
import store from '@/store'
import { translations } from '@/assets/lang/index.js'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: translations
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  data () {
    return {
      theme: 'base',
      host: window.location.host.split('.')[0]
    }
  },
  template: '<App/>',
  components: { App }
})
